<button 
  class="add-button align-self-end" 
  [ngClass]="{ 'material-symbols-outlined': outlined }" 
  [disabled]="disabled"
  (click)="handleClick($event)"
>
  <mat-icon>{{icon}}</mat-icon>
</button>